import $http from './index';
// ticket验证
export function ticektCheck() {
    return $http.post(
        `/user/ticket`, {},
        {
            headers: {
                ticket: window.sessionStorage.getItem('ticket'),
                service: window.sessionStorage.getItem('serviceUrl')
            }
        }
    )
}

//临时
export function loginCas(userName) {
    return $http.get(
        `/cas`,
        {
            params: {
                url: userName,
                ticket: userName,
            },
            headers: { loginType: window.localStorage.getItem('loginType') }
        }
    )
}

// 登录
export function login(userName, password, captcha) {
    return $http
        .post('/login', { username: userName, password: password, captcha: captcha });
}

//用户信息
export function userInfo() {
    return $http
        .post('/user/info')
}

//用户登录
export function userLogin(data) {
    return $http
        .post('/user/login', data)
}
//用户登出
export function userLogOut(data) {
    return $http
        .post('/user/logOut', data)
}

//院系list
export function departmentList(data) {
    return $http
        .post('/department/list', data)
}

//课程list
export function curriculumList(data) {
    return $http
        .post('/curriculum/page', data)
}

export function courseById(data) {
    return $http.post("/curriculum/getById", data)
}

//banner
export function bannerPage(data) {
    return $http
        .post('/banner/page', data)
}

//课程下讲师
export function curriculumLecturer(data) {
    return $http
        .post('/curriculum/lecturer', data)
}

//用户端-课程下视频列表
export function userPageByCurriculum(data) {
    return $http.post("/video/userPageByCurriculum", data);
}
//用户端-专题下视频列表
export function userPageBySubject(data) {
    return $http.post("/video/userPageBySubject", data);
}
//课程下视频列表
export function pageByCurriculum(data) {
    return $http.post("/video/pageByCurriculum", data);
}
//专题下视频列表
export function pageBySubject(data) {
    return $http.post("/video/pageBySubject", data);
}


//讲师管理infoList
export function lecturerPageInfo(data) {
    return $http
        .post('/lecturer/pageInfo', data)
}

export function playVideo(data) {
    return $http.post("/play/play", data);
}

export function playReport(data) {
    return $http.post("/play/report", data);
}

export function playEnd(data) {
    return $http.post("/play/end", data);
}

export function thumbClick(data) {
    return $http.post("/thumbs/thumb", data);
}

export function thumbCancel(data) {
    return $http.post("/thumbs/cancel", data);
}

export function collectSave(data) {
    return $http.post("/collect/save", data);
}

export function transpond(data) {
    return $http.post("/transpond/trans", data);
}


export function countCurriculm(data) {
    return $http.post("/count/curriculm", data);
}

export function countVideo(data) {
    return $http.post("/count/video", data);
}

//我的记录
export function playMypage(data) {
    return $http
        .post('/play/mypage', data)
}
//我的收藏
export function collectPage(data) {
    return $http
        .post('/collect/page', data)
}

export function achievementUser(data) {
    return $http.post("/achievement/user", data);
}


export function collectDelete(data) {
    return $http.post("/collect/delete", data);
}

export function curriculmByUser(data) {
    return $http.post("/count/curriculmByUser", data);
}

export function videoByUser(data) {
    return $http.post("/count/videoByUser", data);
}


// WEBPACK FOOTER //
// ./src/api/api.js